import type {
  CallBuddyOverviewResponse,
  CallBuddyReportParams,
  CallDetail,
  FollowUpReportParams,
  FollowUpReportResponse,
} from '../types/callbuddy'
import { api } from './api'

const BASE_URL = '/api/v1/callbuddy/reports'

const buildQueryString = (params: Record<string, string | undefined>): string => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value))
    }
  })
  return query.toString() ? `?${query.toString()}` : ''
}

export const callBuddyApi = {
  overview: async (params?: CallBuddyReportParams) =>
    (await api.get<CallBuddyOverviewResponse>(`${BASE_URL}/overview/${buildQueryString({...params})}`)).data,
  followUps: async (params?: FollowUpReportParams) =>
    (await api.get<FollowUpReportResponse>(`${BASE_URL}/follow-ups/${buildQueryString({...params})}`)).data,
  callDetail: async (id: string) =>
    (await api.get<CallDetail>(`${BASE_URL}/${id}/detail/`)).data,
  toggleFollowedUp: async (id: string, followed_up?: boolean) =>
    (await api.patch<{ id: string; followed_up: boolean; followed_up_at: string | null }>(
      `${BASE_URL}/${id}/followed-up/`, followed_up !== undefined ? {followed_up} : {},
    )).data,
}
